import styles from "../../styles/General/LinearLoader.module.css"
import { useSelector } from "react-redux";
import { toggleLinearLoader } from "../../store/LoaderSlice";

function LinearLoader(props : any) {

    const { LinearLoader } = useSelector((state : any) => state.loader)
    return (
        LinearLoader.show &&
        <div className={`${styles.linearActivity}`} style={{ background : props.color }}>
            <div className={`${styles.indeterminate} indeterminate`}></div>
        </div>
    )
}

LinearLoader.defaultProps = {
    background : '#EC6303'
}

export default LinearLoader;